import React, { useState, useCallback } from 'react';
import { CalcOverlay, CalcContent, TabContent, TabTransitionOverlay, CalcCloseIconButton } from './styles';
import CommissionCalculator from './CommissionCalculator';
import AreaCalculator from './AreaCalculator';
import MonthlyRentCalculator from './MonthlyRentCalculator';
import Tab from './Tab';
import useDragAndDrop from '../../../hooks/useDragAndDrop';
import { Close } from '@mui/icons-material';

const Calculator = ({ isOpen, onClose }) => {
    const [activeTab, setActiveTab] = useState('commission');
    const [isTransitioning, setIsTransitioning] = useState(false);

    const { modalRef, position, isVisible, handleDragStart, checkModalBoundary, adjustModalPosition } = useDragAndDrop(
        isOpen,
        'calculator'
    );

    // 탭 변경 핸들러
    const handleTabChange = useCallback(
        (newTab) => {
            if (newTab !== activeTab) {
                setIsTransitioning(true);

                setTimeout(() => {
                    setActiveTab(newTab);
                    setIsTransitioning(false);
                }, 200);
            }
        },
        [activeTab]
    );

    const renderCalculator = useCallback(() => {
        switch (activeTab) {
            case 'commission':
                return (
                    <CommissionCalculator
                        checkModalBoundary={checkModalBoundary}
                        adjustModalPosition={adjustModalPosition}
                    />
                );
            case 'area':
                return (
                    <AreaCalculator checkModalBoundary={checkModalBoundary} adjustModalPosition={adjustModalPosition} />
                );
            case 'monthlyRent':
                return (
                    <MonthlyRentCalculator
                        checkModalBoundary={checkModalBoundary}
                        adjustModalPosition={adjustModalPosition}
                    />
                );
            default:
                return (
                    <CommissionCalculator
                        checkModalBoundary={checkModalBoundary}
                        adjustModalPosition={adjustModalPosition}
                    />
                );
        }
    }, [activeTab, checkModalBoundary, adjustModalPosition]);

    if (!isOpen) return null;

    return (
        <CalcOverlay>
            <CalcContent
                ref={modalRef}
                style={{
                    left: position.x,
                    top: position.y,
                    opacity: isVisible ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: isVisible ? 'auto' : 'none',
                }}
                role="dialog"
                aria-modal="true"
                aria-label="계산기 모달"
                aria-describedby="calculator-content"
            >
                <Tab
                    activeTab={activeTab}
                    setActiveTab={handleTabChange}
                    onMouseDown={handleDragStart}
                    onTouchStart={handleDragStart}
                />

                {/* 닫기 버튼 */}
                <CalcCloseIconButton onClick={onClose} aria-label="계산기 모달 닫기">
                    <Close />
                </CalcCloseIconButton>

                {/* 탭 전환 오버레이 */}
                <TabTransitionOverlay className={isTransitioning ? 'active' : ''}>
                    {isTransitioning && <div className="loading-spinner" />}
                </TabTransitionOverlay>

                {/* 선택된 계산기 컴포넌트 렌더링 */}
                <TabContent id="calculator-content" className={`${isTransitioning ? 'transitioning' : ''} fade-in`}>
                    {renderCalculator()}
                </TabContent>
            </CalcContent>
        </CalcOverlay>
    );
};

export default Calculator;
